import axios from 'axios'
import { useRouter } from 'next/router'
import { useEffect, useRef } from 'react'

const useRequest = () => {
  const router = useRouter()
  const request = useRef<any>()
  const lang = router.locale  

  // 创建axios实例
  request.current = axios.create({
    baseURL: '/axiosapi',// 所有的请求地址前缀部分
    timeout: 80000, // 请求超时时间(毫秒)
    withCredentials: true,// 异步请求携带cookie
  })

  // request拦截器
  request.current.interceptors.request.use(
    (config: any) => {

      // 获取token
      // let token = localStorage.getItem("token");
      // if (token) {
      //   // 添加请求头
      //   config.headers["token"] = token
      // }

      if (!config.headers.lang) {
        config.headers["lang"] = lang
      }
      return config
    },
    (error: any) => {
      return Promise.reject(error)
    }
  )

  // response 拦截器
  request.current.interceptors.response.use(
    (response: any) => {
      if (response.data?.code === 500) {

      }
      if (response.data?.code === 208 || response.data?.code === 207) {

      }
      // if (response.data instanceof Blob) {
      //   const reader = new FileReader() as any;
      //   reader.readAsText(response.data, 'utf-8');
      //   reader.onload = function () {
      //     const res = reader.result[0] !== '{' ? 200 : JSON.parse(reader.result)
      //     if (res?.code === 500) {

      //     }
      //   }
      //   return response
      // }
      return response
    },
    (error: any) => {

      if (error.response.status == 401) {

      } else if (error.response.status === 500) {

      }
      return Promise.reject(error)
    }
  )

  return request.current
}

export default useRequest